module.exports = __webpack_public_path__ + "img/douyin.cf417f1e.png";